import { useMutation } from '@apollo/client';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { gql } from '../graphql/generated/gql';
import { useRemoveFromRecentlyViewedPostIds } from '../ui/atoms';

const DELETE_POST_MUTATION = gql(/** @complexity 2 */ `
  mutation deletePost($id: ID!) {
    deletePost(id: $id) {
      id
    }
  }
`);

const deletedPostIdsAtom = atom<Record<string, boolean>>({});

export const useIsPostDeletedLocally = (postId: string) => {
  return useAtomValue(deletedPostIdsAtom)[postId] === true;
};

const useDeletePost = () => {
  const removeFromRecentlyViewedPostIds = useRemoveFromRecentlyViewedPostIds();
  const setDeletedPostIds = useSetAtom(deletedPostIdsAtom);
  const [deletePost] = useMutation(DELETE_POST_MUTATION, {
    update(cache, { data }) {
      if (data?.deletePost) {
        cache.evict({ id: cache.identify(data.deletePost) });
      }
    },
  });

  return useCallback(
    async (id: string) => {
      setDeletedPostIds((prev) => ({ ...prev, [id]: true }));
      removeFromRecentlyViewedPostIds(id);
      await deletePost({ variables: { id } });
    },
    [setDeletedPostIds, removeFromRecentlyViewedPostIds, deletePost],
  );
};

export default useDeletePost;
